<template>
  <div class="m-0 dbozone-font body">
    <div class="col-12 justify-content-center d-flex flex-row header-centilliongod">
      <div class="px-3 col-3 p-0">
        <div class="heading-centilliongod">{{ $t("result.round") }}</div>
        <div class="text-subhead-centilliongod">{{ data.roundId }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-centilliongod">{{ $t("result.bet") + `${currency}` }}</div>
        <div class="text-subhead-centilliongod"> {{ data.count === 0
          ? data.bet
          : data.detail.summary[data.count].bet.amount | currencyFormatter }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-centilliongod">
          {{ $t("result.winlose") + `${currency}` }}
        </div>
        <div class="text-subhead-centilliongod">
          {{ (winlose) | currencyFormatter }}
        </div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-centilliongod">{{ $t("result.balance") + `${currency}` }}</div>
        <div class="text-subhead-centilliongod">{{ balance | currencyFormatter }}</div>
      </div>
    </div>
    <div class="content-result-centilliongod pt-3">
      <div class="text-game-centilliongod">Centillion Gods</div>
      <div class="text-subgame-centilliongod">{{ $t("centilliongod.name") }}</div>
      <div class="text-subgame-centilliongod">
        {{ result.type.replace('_', ' ') }}
      </div>
      <div class="text-date mb-1">{{ data.timestamp }}</div>
      <section v-if="result.type === 'BONUS_GAME'" class="d-flex justify-content-between">
        <div class="col-1 d-flex align-items-center justify-content-center">
          <i class="fas fa-caret-left arrow-side-centilliongod" @click="delCount()"></i>
        </div>
        <div class="text-center pt-4">
          <img
            :src="require(`../../assets/resultGame/centilliongod/bonus/item_${[2, 3].includes(result.perform) ? 2 : result.perform}.png`)"
            alt="" />
          <h2 class="bonus-wining d-flex justify-content-center align-items-center mx-auto mt-5">
            <span>{{ result.winning ? '+' : '' }}</span>
            <span>{{ (result.winning) | currencyFormatter }} {{ currency }}</span>
          </h2>
        </div>
        <div class="col-1 d-flex align-items-center justify-content-center">
          <i v-if="!result.isEndRound" class="fas fa-caret-right arrow-side-centilliongod" @click="addCount()"></i>
        </div>
      </section>
      <section v-else>
        <div class="col-12 justify-content-center d-flex flex-row p-0">
          <div class="col-1 d-flex align-items-center justify-content-center">
            <i v-if="data.count > 0" class="fas fa-caret-left arrow-side-centilliongod" @click="delCount()"></i>
          </div>
          <div class="all-table-centilliongod container d-flex flex-column justify-content-center">
            <table>
              <tbody>
                <tr v-for="(row, index) in result.symbols[0]" :key="index">
                  <td v-for="(col, i) in result.symbols" :key="`${index}${i}`" class="p-0">
                    <img class="icon-symbol"
                      :src="require(`../../assets/resultGame/centilliongod/symbol_${col[index]}.png`)" alt="" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-1 d-flex align-items-center justify-content-center">
            <i v-if="!result.isEndRound" class="fas fa-caret-right arrow-side-centilliongod" @click="addCount()"></i>
          </div>
        </div>
        <div v-if="data.freeSpin" class="text-subgame-centilliongod mb-1">
          {{
            $t('result.freespin') +
            ' ' +
            result.freeSpinsPlayed +
            '/' +
            result.freeSpinsCount
          }}
        </div>
        <div class="col-12 justify-content-center d-flex flex-row" v-if="result.winning">
          <hr class="line col-3" />
          <div class="text-detail align-items-center d-flex px-3">{{ $t("result.detail") }}</div>
          <hr class="line col-3" />
        </div>
        <div v-if="result.featureBuy" class="text-feature-centilliongod">Feature Buy</div>
        <div class="col-12 justify-content-center d-flex flex-row mt-4">
          <div class="bet-box-centilliongod p-2 px-3" v-if="result.winning">
            <div class="bet-warpper item" v-for="(detail, index) in result.winCombos" :key="index">
              <div class="d-flex item justify-content-between px-1 mb-2">
                <div class="bet-wrapper-centilliongod item">
                  <div class="d-flex justify-content-start bet-wrapper-centilliongod item">
                    <img class="icon-detail-hcl"
                      :src="require(`../../assets/resultGame/centilliongod/symbol_${detail[1]}.png`)" alt="" />
                    <div class="d-flex flex-column align-items-start justify-content-center">
                      <p class="my-1 yellow">{{ `Line ${detail[0] + 1}` }}</p>
                      <p class="my-1 yellow">{{ `${detail[2]} ` + $t("result.kind") }}</p>
                    </div>
                    <div class="d-flex flex-column justify-content-center px-3">
                      <p class="my-1">{{ currency }} {{ result.winnings[index] | currencyFormatter }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="bet-warpper item" v-if="result.winShowsCount === 0">
              <div class="d-flex justify-content-between mt-5">
                <div class="bet-wrapper-centilliongod item align-content-center d-flex">
                  <div class="d-flex justify-content-center bet-wrapper-centilliongod item align-content-center p-3">
                    <p class="my-1 red">{{ "No Winnings" }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import utils from "../../services/utils";
export default {
  name: "result-centilliongod",
  props: {
    data: Object,
  },
  data() {
    return {
      headerHeight: null,
      dateTimeFormatter: function formatter(date) {
        return utils.dateTimeFormatter(date);
      },
      tokenData: utils.getTokenData(this.$route.query.t)
      ,
      currency: this.data.currency ? (this.data.detail.isCoin ? 'AMS' : this.data.currency) : "THB",
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
      isFreeSpin: (!this.data.detail.type === 'SPIN' && !this.data.detail.isEndRound) || this.data.count,
      result: this.data,
      count: this.data.count,
    };
  },
  async created() {
    if (this.isback) {
      this.data.count = this.data.detail.summary.length - 1;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
    else {
      this.data.count = 0;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
  },
  methods: {
    mapSymbol(result) {
      if (!this.currency.includes("(")) {
        this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
      }
      this.result = result;
      this.isEndRound = result.isEndRound;
      this.winnings = result.winnings;
      this.isFreespin =
        result.type === "FREESPIN" ||
        result.type === "FREERESPIN" ||
        result.type === "BONUS_GAME";

      let currentBet = 0;
      currentBet = this.data.count != 0 ? result.bet.amount : this.data.detail.roundAmount;
      this.winlose = result.win - currentBet;
      this.bet = result.bet;
      this.balance = result.balance;
      if (result.isCoin) this.currency = 'AMS';
    },
    onResize() {
      this.headerHeight = document.getElementsByClassName(
        "header"
      )[0].offsetHeight;
    },
    async addCount() {
      this.data.count += 1;
      if (this.data.count > this.data.detail.summary.length - 1) {
        this.pages += 1;
        this.$emit('fetchResult', this.page + 1)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }
    },
    async delCount() {
      this.data.count -= 1;
      if (this.page > 0) {
        this.pages -= 1;
        this.$emit('fetchResult', this.page - 1, true)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }
    },
  },
};
</script>

<style scoped>
.bonus-wining {
  width: 230px;
  height: 70px;
  background-color: #A11010;
  border-radius: 14px;
  color: #FFE463;
}

.icon-detail-hcl {
  width: 90px;
  padding: 10px;
  height: 90px;
}

.arrow {
  color: #cac095;
  text-align: center;
}

.arrow-side-centilliongod {
  cursor: pointer;
  color: #cac095;
  text-align: center;
  font-size: 90px;
}

.bet-box-centilliongod {
  background: #000000;
  border-radius: 10px;
  min-height: 200px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bet-wrapper-centilliongod .item {
  color: #fff;
  background: #a11010;
  line-height: 1;
  border-radius: 10px;
  border: 1.5px solid #a11010;
}

.bet-box-centilliongod .bet-wrapper-centilliongod:not(:first-child) .item {
  margin-top: 10px;
}

.bet-wrapper-centilliongod,
.result-wrapper {
  font-size: 35px;
}

.header-centilliongod {
  background: #a11010;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-centilliongod {
  color: #ffe463;
  text-align: center;
}

.content-result-centilliongod {
  background: #391818;
  height: 150vh;
  width: 100%;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.title>.heading-centilliongod {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title>.sub {
  font-size: 30px;
  line-height: 1;
}

.text-game-centilliongod {
  text-shadow: 0px 0px 20px #ffe463;
  color: #ffe463;
  font-weight: bold;
  font-size: 25px;
  text-align: center;
}

.text-subhead-centilliongod {
  font-size: px;
  color: white;
  text-align: center;
}

.text-subgame-centilliongod {
  font-size: 20px;
  color: white;
  text-align: center;
}

.text-feature-centilliongod {
  font-size: 30px;
  color: white;
  text-align: center;
}

.text-date {
  font-size: px;
  color: #c7b873;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #c7b873;
  text-align: center;
}

.icon-symbol {
  width: 100%;
}

.bet-box-centilliongod {
  min-width: 600px;
  max-width: auto;
}

.all-table-centilliongod {
  background: url("~@/assets/resultGame/centilliongod/centilliongod_frame.png") no-repeat;
  background-size: 770px 470px;
  width: 770px;
  height: 470px;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
  padding-top: 20px;
}

@media screen and (max-width: 1030px) {
  .all-table-centilliongod {
    background-size: 770px 470px;
    width: 770px;
    height: 470px;
    padding-top: 20px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-centilliongod {
    font-size: 60px;
  }

  .bet-box-centilliongod {
    min-width: 580px;
    max-width: auto;
    height: 280px;
  }

  .bet-wrapper-centilliongod,
  .result-wrapper {
    font-size: 35px;
  }
}

@media screen and (min-width: 1060px) {
  .d-md-spec-flex {
    display: flex;
  }

  .result-wrapper .symbol {
    width: 140px;
  }

  .bet-wrapper-centilliongod,
  .result-wrapper {
    font-size: 33px;
  }
}

.line {
  background-color: #c7b873;
  height: 2px;
  width: 100%;
}

.red {
  color: #ff0000;
}

.yellow {
  color: #ffe463;
}

@media screen and (max-width: 770px) {
  .heading-centilliongod {
    font-size: 18px;
  }

  .all-table-centilliongod {
    background-size: 540px 330px;
    width: 540px;
    height: 330px;
    padding-top: 20px;
  }

  .text-subhead-centilliongod {
    font-size: 18px;
  }

  .arrow-side-centilliongod {
    font-size: 50px;
  }

  .bet-box-centilliongod {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #c7b873;
    text-align: center;
  }
}

@media screen and (max-width: 480px) {
  .header>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-centilliongod {
    font-size: 12px;
  }

  .all-table-centilliongod {
    background-size: 305px 180px;
    width: 305px;
    height: 180px;
    padding-top: 10px;
  }

  .text-subhead-centilliongod {
    font-size: 14px;
  }

  .bet-box-centilliongod {
    min-width: 230px;
    max-width: auto;
    height: 200px;
  }

  .bet-wrapper-centilliongod,
  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-hcl {
    width: 60px;
    height: 60px;
    padding: 5px;
  }
}
</style>
